// Betsoft Game Images - Local Assets + Official Betsoft thumbnails
// Uses 840x500 wide thumbnails from /betsoft/thumbs/ as primary source for slots
// Uses official betsoft.com thumbnails for table games, video poker, and arcade games

// Game name overrides - fix incorrect/ugly names from Betsoft API
export const GAME_NAME_OVERRIDES = {
  "576": "Slots Angels NJP",
  "872": "Supreme 777 Jackpots",
  "555": "The Glam Life NJP",
  "2": "Lucky Seven",
};

// Category-based fallback images for games without dedicated thumbnails
export const CATEGORY_IMAGES = {
  blackjack: "/api/game-assets/betsoft/category_thumbs/blackjack.png",
  roulette: "/api/game-assets/betsoft/category_thumbs/roulette.png",
  poker: "/api/game-assets/betsoft/category_thumbs/poker.png",
  table: "/api/game-assets/betsoft/category_thumbs/table_games.png",
  plinko: "/api/game-assets/betsoft/category_thumbs/plinko.png",
};

// Official Betsoft image URLs for table games, video poker, and arcade games
const BSG_CDN = "https://betsoft.com/wp-content/uploads";
const BETSOFT_OFFICIAL_IMAGES = {
  // Table Games - Blackjack
  "64": `${BSG_CDN}/2022/02/21-burn-blackjack-1.jpg`,           // 21 Burn Blackjack
  "195": `${BSG_CDN}/2022/02/american-blackjack-600x383.jpg`,   // American Blackjack
  "191": `${BSG_CDN}/2022/02/european-blackjack-600x383.jpg`,   // European Blackjack
  "63": `${BSG_CDN}/2022/02/single-deck-blackjack-600x383.jpg`, // Single Deck Blackjack
  "44": `${BSG_CDN}/2022/02/super-7-blackjack-600x383.jpg`,     // Super 7 Blackjack
  "82": `${BSG_CDN}/2022/02/pirate-21-600x383.jpg`,             // Pirate 21
  "81": `${BSG_CDN}/2022/02/pontoon-600x383.jpg`,               // Pontoon
  // Table Games - Roulette
  "5": `${BSG_CDN}/2022/02/american-roulette-600x383.jpg`,      // American Roulette
  "79": `${BSG_CDN}/2022/02/european-roulette-600x383.jpg`,     // European Roulette
  "198": `${BSG_CDN}/2022/02/american-roulette-600x383.jpg`,    // VIP American Roulette (same artwork)
  "197": `${BSG_CDN}/2022/02/european-roulette-600x383.jpg`,    // VIP European Roulette (same artwork)
  "278": `${BSG_CDN}/2022/02/zoom-roulette-600x383.jpg`,        // Zoom Roulette
  // Table Games - Poker
  "12": `${BSG_CDN}/2022/02/caribbean-poker-600x383.jpg`,       // Caribbean Poker
  "203": `${BSG_CDN}/2022/02/oasis-poker-600x383.jpg`,          // Oasis Poker
  "105": `${BSG_CDN}/2022/02/triple-edge-poker-600x383.jpg`,    // Triple Edge Poker
  "48": `${BSG_CDN}/2022/02/top-card-trumps-600x383.jpg`,       // Top Card Trumps
  // Table Games - Other
  "13": `${BSG_CDN}/2022/02/baccarat-600x383.jpg`,              // Baccarat
  "10": `${BSG_CDN}/2022/02/craps-600x383.jpg`,                 // Craps
  "9": `${BSG_CDN}/2022/02/pai-gow-600x383.jpg`,                // Pai Gow
  "94": `${BSG_CDN}/2022/02/red-dog-600x383.jpg`,               // Red Dog
  "244": `${BSG_CDN}/2022/02/three-card-rummy-600x383.jpg`,     // Three Card Rummy
  "872": `${BSG_CDN}/2023/04/supreme-777-jackpots-game-thumbnail-600x383.jpg`, // Supreme 777 Jackpots
  // Video Poker
  "29": `${BSG_CDN}/2022/06/deuces-wild-thumbnail-800x510-min.jpg`, // Deuces Wild
  // Arcade / Plinko
  "1000": `${BSG_CDN}/2026/01/3-pots-of-olympus-game-thumbnail.jpg`, // 3 Pots of Olympus
  "940": `${BSG_CDN}/2024/09/olympus-plinko-game-thumbnail-600x383.jpg`, // Olympus Plinko
  "997": `${BSG_CDN}/2025/10/plinko-cup-game-thumbnail-600x383.jpg`,    // Plinko Cup
  "915": `${BSG_CDN}/2023/12/plinko-rush-game-thumbnail-600x383.jpg`,   // Plinko Rush
  "959": `${BSG_CDN}/2025/03/diamond-mines-game-thumbnail-tm-600x383.jpg`, // Diamond Mines
  "863": `${BSG_CDN}/2023/02/triple-cash-or-crash-game-thumbnail-600x383.jpg`, // Triple Cash or Crash
  // Newest releases (June 2026)
  "1011": "/api/game-assets/games/betsoft/the-gem-master-500x500.webp",            // The Gem Master (Game ID 1011 — live 2026-06-25)
  // Newest releases (August 2026 + Feb 2026) — official 500x500 tiles shipped
  // by Betsoft. Kept in this map so any render path that goes through
  // getBetsoftGameImage() (mobile featured rail, category widgets, etc.)
  // uses the correct art instead of falling through to a stale name-match.
  //
  // NOTE: Paths must live under /api/game-assets/... — Emergent's preview
  // edge proxy (Express) claims every /games/* URL for the React SPA, so
  // bare /games/betsoft/*.jpg returns index.html and the tile appears
  // broken. The /api/game-assets/games/betsoft/ mount goes straight to
  // FastAPI's StaticFiles handler.
  "1013": "/api/game-assets/games/betsoft/3-million-bc-500x500.jpg",         // 3 Million B.C.
  "1014": "/api/game-assets/games/betsoft/the-bonus-day-500x500.jpg",        // The Bonus Day
  "1015": "/api/game-assets/games/betsoft/the-governor-500x500.jpg",         // The Governor
  "1016": "/api/game-assets/games/betsoft/the-robbery-500x500.jpg",          // The Robbery
  "1017": "/api/game-assets/games/betsoft/the-oil-barons-500x500.jpg",       // The Oil Barons — official Betsoft key art
  "1018": "/api/game-assets/games/betsoft/gold-nugget-rush-2-500x500.jpg",   // Gold Nugget Rush 2
  "1019": "/api/game-assets/games/betsoft/the-game-show-500x500-v2.jpg",     // The Game Show — freshly attached artwork, v2 to duck CDN cache
  "1020": "/api/game-assets/games/betsoft/last-laugh-500x500.webp",          // Last Laugh
  "1022": "/api/game-assets/games/betsoft/super-stampede-500x500.jpg",       // Super Stampede
  "1024": "/api/game-assets/games/betsoft/good-girl-bad-girl-2-500x500.jpg", // Good Girl Bad Girl 2 — Sep 2026 release
  "1025": "/api/game-assets/games/betsoft/the-vip-500x500.jpg",              // The VIP — Sep 2026 release
};

// Map game IDs with missing images to their category fallback (only used if official URL fails)
export const GAME_CATEGORY_MAP = {
  // Blackjack variants
  "64": "blackjack",   // 21 Burn Blackjack
  "195": "blackjack",  // American Blackjack
  "191": "blackjack",  // European Blackjack
  "63": "blackjack",   // Single Deck Blackjack
  "44": "blackjack",   // Super 7 Blackjack
  "82": "blackjack",   // Pirate 21
  "81": "blackjack",   // Pontoon
  // Roulette variants
  "5": "roulette",     // American Roulette
  "79": "roulette",    // European Roulette
  "198": "roulette",   // VIP American Roulette
  "197": "roulette",   // VIP European Roulette
  "278": "roulette",   // Zoom Roulette
  // Poker variants
  "12": "poker",       // Caribbean Poker
  "203": "poker",      // Oasis Poker
  "105": "poker",      // Triple Edge Poker
  "29": "poker",       // Deuces Wild
  "48": "poker",       // Top Card Trumps
  // Other table games
  "13": "table",       // Baccarat
  "10": "table",       // Craps
  "9": "table",        // Pai Gow
  "94": "table",       // Red Dog
  "244": "table",      // Three Card Rummy
  // Plinko / Soft games
  "1000": "plinko",    // 3 Pots of Olympus
  "940": "plinko",     // Olympus Plinko
  "997": "plinko",     // Plinko Cup
  "915": "plinko",     // Plinko Rush
  "959": "plinko",     // Diamond Mines
};

// All available thumbnail filenames (without _500x500.jpg suffix)
const THUMB_FILES = new Set([
  "2MillionBC","3PotsOfLunarWolf","3PotsOfOlympus","4Seasons","72Fortunes","7FortuneFrenzy",
  "7thHeaven","88FrenzyFortune","ABigCatch","AChristmasCarol","ANightInParis",
  "AfterNightFalls","AlkemorsElements","AlkemorsTower","AprilFury","Arrival",
  "AtTheCopa","AtTheMovies","BackToVenus","BambooRush","BarbaryCoast",
  "Birds","BlackGold","BloodEternal","BookOfDarkness","BookOfHelios",
  "Boomanji","BoundingLuck","CaishenGodOfFortune","CaishensArrival","CaptainsQuestTreasureIsland",
  "CarnavalForever","CarnivalRush","CharmsAndClovers","CharmsAndTreasures","ChilliPop",
  "ChilliPopGetThemAll","CoinsOfAlkemor","CoinsOfAlkemorExtremeMagic","CoinsOfChristmas","CoinsOfDragon",
  "CoinsOfHalloween","CoinsOfLeprechaun","CoinsOfRa","CoinsOfRaDeluxe","CoinsOfRaPower",
  "CoinsOfZeus","DimSumPrize","DiscoFarm","DrJekyllMrHyde","DragonAndPhoenix",
  "DragonKings","Enchanted","EnchantedForestOfFortune","EventHorizon","Expansion",
  "FaFaTwins","FaerieSpells","FireAndSteel","FrankenslotsMonster","FruitBatCrazy",
  "FruitZen","FuryDragon","GeminiJoker","Gemmed","GeniesFortune",
  "GiovannisGems","Gladiator","GoldCanyon","GoldDiggers","GoldNuggetRush",
  "GoldTigerAscent","GoldenDestiny","GoldenDragonInferno","GoldenHorns","GoodGirlBadGirl",
  "Great88","GreedyGoblins","GreedyGoblinsThatStoleChristmas","GypsyRose","HatTrickHero",
  "HeartsDesire","Heist","HeistBankRush","HotLucky7s","HouseOfFun",
  "IslandDesire","ItCameFromVenus","JumboJoker","JungleStripes","KawaiiKitty",
  "KenseiBlades","LavaGold","LegendOfTheNile","Lost","LostMysteryChests",
  "Lucky7","MIlesBellhouseAndTheGearsOfTime","MadScientistBreakingBeakers","MadderScientist","MammaMia",
  "MegaGems","MegaGlamLife","MonsterPop","MoreGoldDiggin","MrMacau",
  "MrVegas","MrVegas2","MysticHive","OgreEmpire","OnceAgainUponATime",
  "OnceUponATime","PacoAndThePoppingPeppers","PhoSho","Pinocchio","PotsOfGreatFortune",
  "PrimalHunt","PrimalWilderness","PuppyLove","QuestToTheWest","RagsToWitches",
  "ReelsOfWealth","ReturnToParis","ReturnToTheCopa","RiseOfTriton","RockStar",
  "RockStarWorldTour","RooksRevenge","SafariSam","SafariSam2","SinCityNights",
  "SleighinIt","SlotsAngels","SpinfinityMan","SpringTails","Stacked",
  "Stampede","StampedeGold","StayFrosty","SugarPop","SugarPop2",
  "SuperGoldenDragonInferno","SuperSugarPop","SuperSweets","SushiBar","TakeOlympus",
  "TakeSantasShop","TakeTheBank","TakeTheKingdom","TakeTheShot","TakeTheVault",
  "ThaiBlossom","TheAngler","TheCuriousMachine","TheExterminator","TheGlamLife",
  "TheGoldenOwlOfAthena","TheHive","TheKingdomOfCardia","TheKingOfSocialMedia","TheMagicShoppe","TheSlotfather",
  "TheSlotfatherBookOfWins","TheSlotfatherPartII","TheTipsyTourist","TheTipsyTouristBeachBonanza",
  "TheTipsyTouristChristmasVacation","TheTrueSheriff","TigersClaw","TigersLuck","TotalOverdrive",
  "TowerOfFortuna","TreasureRoom","TreasuresOfCleopatra","TrinityReels","TripleJuicyDrops",
  "TripleLucky8s","TrueIllusions","Tycoons","TycoonsBillionaireBucks","UltimateGoldenDragonInferno",
  "UnderTheBed","UnderTheSea","VikingAge","VikingVoyage","WeekendInVegas",
  "WildDrops","WildsOfFortune","WindsOfWealth","WishGranted","WolfMoonRising",
  "Woodlanders","YakYetiAndRoll"
]);

// Lowercase lookup
const THUMB_LOOKUP = {};
THUMB_FILES.forEach(name => { THUMB_LOOKUP[name.toLowerCase()] = name; });

// Direct game ID -> thumbnail filename for games with tricky/non-obvious names
const GAME_ID_MAP = {
  // Colon-separated names
  "937": "CaishenGodOfFortune",
  "885": "MrVegas2",
  "834": "MIlesBellhouseAndTheGearsOfTime",
  "869": "CaptainsQuestTreasureIsland",
  "917": "TycoonsBillionaireBucks",
  "934": "TheSlotfatherBookOfWins",
  "931": "HeistBankRush",
  "923": "RockStarWorldTour",
  "914": "EnchantedForestOfFortune",
  "500": "DrJekyllMrHyde",
  "910": "AprilFury",
  "929": "TigersLuck",
  "952": "UltimateGoldenDragonInferno",
  "987": "ReturnToTheCopa",
  "938": "ChilliPopGetThemAll",
  "971": "CoinsOfAlkemorExtremeMagic",
  "965": "MadScientistBreakingBeakers",
  "991": "GreedyGoblinsThatStoleChristmas",
  "948": "SuperSugarPop",
  "984": "TheTipsyTouristChristmasVacation",
  "957": "TheTipsyTouristBeachBonanza",
  "978": "CoinsOfRaDeluxe",
  "961": "CoinsOfRaPower",
  "1000": "3PotsOfOlympus",
  "1010": "TheKingdomOfCardia",
  "976": "3PotsOfLunarWolf",
  // NJP variants -> base game thumb
  "723": "TheSlotfather",
  "708": "CharmsAndClovers",
  "880": "SleighinIt",
  "696": "ANightInParis",
  "564": "AtTheCopa",
  "568": "MrVegas",
  "799": "FaerieSpells",
  "580": "GoodGirlBadGirl",
  "572": "GreedyGoblins",
  "576": "SlotsAngels",
  "797": "DragonKings",
  "555": "TheGlamLife",
  "878": "RagsToWitches",
  "563": "TreasureRoom",
  "556": "Tycoons",
  "735": "MegaGems",
  "743": "MegaGlamLife",
  "795": "ReelsOfWealth",
  "780": "LegendOfTheNile",
  "739": "Enchanted",
  "704": "TheSlotfatherPartII",
  "887": "HeartsDesire",
  "852": "ThaiBlossom", // API says "Thai Blossoms" but thumb is "ThaiBlossom"
  // Plus variants
  "482": "PuppyLove",
  "731": "ItCameFromVenus",
  "461": "TheCuriousMachine",
  // Special name mappings
  "784": "SugarPop2",
  "888": "HotLucky7s",
  "801": "YakYetiAndRoll",
  "947": "CoinsOfAlkemor",
  "927": "CoinsOfRa",
  "224": "2MillionBC",
  "225": "PacoAndThePoppingPeppers",
  "846": "7FortuneFrenzy",
  "849": "88FrenzyFortune",  // API: "88 Frenzy" but thumb is "88FrenzyFortune"
  "700": "Great88",
  "692": "FaFaTwins",
  "751": "TheMagicShoppe",
  "2": "Lucky7",
  "647": "FrankenslotsMonster",
  "277": "RooksRevenge",
  "759": "GiovannisGems",
  "619": "AChristmasCarol",
};

// Clean game name: strip Hold & Win, NJP, JACKPOTS, Plus, colons
function cleanGameName(name) {
  if (!name) return '';
  return name
    .replace(/\s*-\s*Hold\s*&?\s*Win\s*/gi, '')
    .replace(/\s*-\s*JACKPOTS\s*-?\s*/gi, '')
    .replace(/\s*NJP\s*(Plus)?\s*/gi, '')
    .replace(/\s*Plus\s*$/gi, '')
    .replace(/:\s*.*/g, '')
    .replace(/[™®–—''!?.']/g, '')
    .replace(/,/g, '')
    .replace(/&/g, 'And')
    .trim();
}

function toPascalKey(str) {
  return str
    .split(/[\s\-]+/)
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');
}

function findThumbKey(gameName) {
  if (!gameName) return null;
  const cleaned = cleanGameName(gameName);
  const key = toPascalKey(cleaned);

  if (THUMB_FILES.has(key)) return key;
  if (THUMB_LOOKUP[key.toLowerCase()]) return THUMB_LOOKUP[key.toLowerCase()];

  // Try with "The" prefix
  if (THUMB_FILES.has("The" + key)) return "The" + key;
  if (THUMB_LOOKUP[("the" + key).toLowerCase()]) return THUMB_LOOKUP[("the" + key).toLowerCase()];

  // Try without "The"
  const noThe = key.startsWith("The") ? key.slice(3) : null;
  if (noThe && THUMB_FILES.has(noThe)) return noThe;
  if (noThe && THUMB_LOOKUP[noThe.toLowerCase()]) return THUMB_LOOKUP[noThe.toLowerCase()];

  return null;
}

// Badge files
export const BETSOFT_BADGES = {
  buyBonusBlue: "/api/game-assets/betsoft/badges/Badge-BuyBonus-Blue.png",
  buyBonusGreen: "/api/game-assets/betsoft/badges/Badge-BuyBonus-Green.png",
  buyBonusOrange: "/api/game-assets/betsoft/badges/Badge-BuyBonus-Orange.png",
  holdAndWin: "/api/game-assets/betsoft/badges/Badge-HoldAndWin.png",
  jackpot: "/api/game-assets/betsoft/badges/Badge-Jackpot.png",
};

// Holiday banner games
export const HOLIDAY_BANNER_GAMES = [
  "72Fortunes","AprilFury","BookOfHelios","BoundingLuck","CaptainsQuestTreasureIsland",
  "CharmsAndTreasures","EnchantedForestOfFortune","Expansion","GoldenDragonInferno",
  "HeartsDesire","HotLucky7s","MrVegas2","PhoSho","RagsToWitches",
  "RiseOfTriton","SleighinIt","SuperGoldenDragonInferno","TrinityReels",
  "TripleLucky8s","TycoonsBillionaireBucks","WildsOfFortune","WindsOfWealth",
  "WishGranted","Woodlanders"
];

// Branded local placeholder. Used when a Betsoft game has no mapped thumbnail
// (Betsoft's feed omits imageUrl for ~220/235 titles). Preferable to a generic
// Unsplash stock photo, which caused the "same slot machine image on every new
// Betsoft tile" issue when the full catalog was surfaced.
const FALLBACK = "/api/game-assets/games/betsoft/_placeholder.jpg";

// Main function: get image for a Betsoft game
export const getBetsoftGameImage = (gameId, gameName) => {
  const idStr = String(gameId);

  // 1. Check for official Betsoft images (table games, video poker, arcade/plinko)
  if (BETSOFT_OFFICIAL_IMAGES[idStr]) {
    return BETSOFT_OFFICIAL_IMAGES[idStr];
  }

  // 2. Check direct ID mapping (skip null entries)
  if (GAME_ID_MAP[idStr] && GAME_ID_MAP[idStr] !== null) {
    const mapped = GAME_ID_MAP[idStr];
    if (THUMB_FILES.has(mapped)) return `/api/game-assets/betsoft/thumbs/${mapped}_840x500.jpg`;
    return `/api/game-assets/betsoft/logos/${mapped}_287x193.jpg`;
  }

  // 3. Try name matching against thumbs
  const key = findThumbKey(gameName);
  if (key) return `/api/game-assets/betsoft/thumbs/${key}_840x500.jpg`;

  // 4. Fallback — use a guaranteed-working local default. The previous
  //    https://swmd.bfrnd.net/... URL is DNS-unreachable from our pod and
  //    renders as a broken image. The Unsplash FALLBACK above is a safer
  //    default until the game gets its own thumbnail mapping.
  return FALLBACK;
};

export default { getBetsoftGameImage, BETSOFT_BADGES, HOLIDAY_BANNER_GAMES, GAME_CATEGORY_MAP, CATEGORY_IMAGES };
